import { render, staticRenderFns } from "./Home_new.vue?vue&type=template&id=6c884bbc&scoped=true&"
import script from "./Home_new.vue?vue&type=script&lang=js&"
export * from "./Home_new.vue?vue&type=script&lang=js&"
import style0 from "./Home_new.vue?vue&type=style&index=0&id=6c884bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c884bbc",
  null
  
)

export default component.exports